import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import pushToAdQueue from '../../action/pushToAdQueue';
import shiftAdQueue from '../../action/shiftAdQueue';
import rawMarkup from '../../util/rawMarkup';
import { initAdSession, getAdUnitPackage } from '../../util/adUtils';
import { appContext } from '../../util/decorators';
import pubSub from '../../util/pubSub';
import getScrollTop from '../../util/getScrollTop';
import csidBuilder from '../../util/csidBuilder';
import PictureWithPreload from '../PictureWithPreload.jsx';
import Picture from '../Picture.jsx';
import VideoPlayer from '../VideoPlayer.jsx';
import VideoPlayerMessageWrapper from '../VideoPlayerMessageWrapper.jsx';
import ContentMeta from '../ContentMeta.jsx';
import FeedContainerList from '../NewsFeed/FeedContainerList.jsx';
//import ArticleShare from './ArticleShare.jsx';
import MarkdownConverter from '../MarkdownConverter.jsx';
import AdUnit from '../Ads/AdUnit.jsx';
import EnetpulseWidget from '../EnetpulseWidget.jsx';
import FactBox from './FactBox.jsx';
import Poll from './Poll.jsx';
import Slider from './Slider.jsx';
import FbCommentBox from './FbCommentBox.jsx';
import adConfigs from '../../config/adConfig';
import GoogleArticleRichCard from './GoogleArticleRichCard.jsx';

import Target from './Target';

import linkTag2Initializer from '../../util/linkTag2Initializer';

const AD_LOAD_DISTANCE = 30;

const mapStateToProps = state => ({
  adQueue: state.ads.adQueue,
  sovSeed: state.ads.sovSeed,
  windowSize: state.events.windowSize,
  breakpoint: state.events.breakpoint,
  adConfig: adConfigs[state.country],
  country: state.country,
  routeParams: state.routeParams,
});
@linkTag2Initializer()
@connect(mapStateToProps)
@appContext
export default class Article extends React.PureComponent {
  static propTypes = {
    adQueue: React.PropTypes.array,
    windowSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number,
    }),
    adConfig: React.PropTypes.object,
    article: React.PropTypes.shape({
      id: React.PropTypes.string.isRequired,
      slug: React.PropTypes.string,
      title: React.PropTypes.string,
      authors: React.PropTypes.array,
      related: React.PropTypes.array,
      preamble: React.PropTypes.string,
      hasMarkdown: React.PropTypes.bool,
      text: React.PropTypes.shape({
        body: React.PropTypes.string,
      }),
      pictures: React.PropTypes.arrayOf(React.PropTypes.shape({
        data: React.PropTypes.shape({
          mediaGuid: React.PropTypes.string,
          url: React.PropTypes.url,
        }),
      })),
      sportStatWidgets: React.PropTypes.array,
      factBoxWidgets: React.PropTypes.array,
      videos: React.PropTypes.arrayOf(React.PropTypes.shape({
        data: React.PropTypes.shape({
          mediaGuid: React.PropTypes.string,
          fwAssetId: React.PropTypes.string,
        }),
      })),
    }),
    autoplay: React.PropTypes.bool,
    firstArticle: React.PropTypes.bool,
    dispatch: React.PropTypes.func,
    breakpoint: React.PropTypes.number,
    csidCompetition: React.PropTypes.string,
    country: React.PropTypes.string,
    sovSeed: React.PropTypes.string,
    routeParams: React.PropTypes.object,
    videoSuggestions: React.PropTypes.array,
    inline: React.PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      loadAdUnits: false,
      disableAdUnit: false,
    };

    this.callback = this.callback.bind(this);
    this.hasPushedToQueue = false;
    this.hasLoadedAds = false;
    this.id = `libellus-a-${this.props.article.id}`;
  }

  componentWillMount() {
    if (this.props.firstArticle && this.props.breakpoint) {
      this.setState({
        loadAdUnits: true,
      });
    }
  }

  componentDidMount() {
    this.scrollSubscription = pubSub.subscribe('scroll', (scrollTop) => this.adTrigger(
      this.props.adQueue,
      scrollTop,
      this.props.windowSize,
      this.props.breakpoint
    ));

    if (this.props.firstArticle) {
      this.hasPushedToQueue = true;
      this.props.dispatch(pushToAdQueue(this.id));
    }
    
  }

  
  
  componentWillReceiveProps({ adQueue, windowSize, breakpoint }) {
    this.adTrigger(adQueue, getScrollTop(), windowSize, breakpoint);
  }

  componentWillUnmount() {
    this.scrollSubscription.remove();
  }

  getVideoElementId(article) {
    return `video-player-article-${article.id}`;
  }

  getCsid(breakpoint) {
    if (!breakpoint) return null;
    const { article, csidCompetition, country, routeParams: { blogs, podcasts } } = this.props;
    const sportParam = _.get(article, 'tags.sports[0].en.slug');
    let csidParam;
    let mediaName;

    if (blogs) {
      csidParam = 'blogs';
      mediaName = _.get(article, 'tags.blogs[0]');
    } else if (podcasts) {
      csidParam = 'pods';
      mediaName = _.get(article, 'tags.podcasts[0]');
    }

    return csidBuilder({
      breakpoint,
      country,
      csidParam,
      mediaName,
      sportParam,
      competitionParam: csidCompetition,
    });
  }

  adTrigger(adQueue, scrollTop, windowSize, breakpoint) {
    if (breakpoint && !this.hasLoadedAds && adQueue && adQueue[0] === this.id) {
      this.hasLoadedAds = true;
      const csid = this.getCsid(breakpoint);

      if (!csid) return;

      this.setState({
        loadAdUnits: true,
      }, () => {
        let adParams = {};

        if (!_.isEmpty(this.props.article.videos)) {
          const id = this.getVideoElementId(this.props.article);
          if (window.videoPlayers && window.videoPlayers[id]) {
            window.videoPlayers[id].on('adDisplayFinish', () => {
              this.setState({
                disableAdUnit: true,
              });
            });
          }
        } else {
          if (this.props.firstArticle) {
            adParams = {
              method: 'linkTag2',
              adConfig: this.props.adConfig,
              csid,
              sovSeed: this.props.sovSeed,
              articleSlug: this.props.article.slug,
            };
          } else {
            adParams = {
              method: 'activeSlot',
              adConfig: this.props.adConfig,
              adType: 'Insider',
              id: this.id,
              articleSlug: this.props.article.slug,
              csid,
              breakpoint,
              sovSeed: this.props.sovSeed,
              country: this.props.country,
            };
          }
        }

        initAdSession(adParams);
      });
    }

    if (
      !this.hasPushedToQueue &&
      this.hasReachedAdTrigger(scrollTop, windowSize.height)
    ) {
      this.hasPushedToQueue = true;
      this.props.dispatch(pushToAdQueue(this.id));
    }
  }

  hasReachedAdTrigger(scrollTop, windowHeight) {
    return scrollTop + windowHeight > this.refs.article.getBoundingClientRect().top + scrollTop - AD_LOAD_DISTANCE;
  }

  callback() {
    this.props.dispatch(shiftAdQueue());
  }
  
  hasAutoplay() {
      return (
        _.has(this.props.article, ['tags', 'freeTexts']) &&
        _.includes(this.props.article.tags.freeTexts, 'autoplay')
      );
    }
  

  render() {
    if (this.hasAutoplay()) {
  	console.log(` Tan:  ` +  this.hasAutoplay());
  }else {
  	//console.log(` Tan false:  ` +  this.hasAutoplay());
  
  }
  const autoplay_freetexts = this.hasAutoplay();
  
    const { article, firstArticle, country, breakpoint, article: { sportStatWidgets, text, factBoxWidgets, videos, polls }, inline } = this.props;
    const csid = this.getCsid(breakpoint);
    const enetPulseWidgets = _.filter(sportStatWidgets, { provider: 'enetpulse' });

    const relatedBox = !_.isEmpty(article.relatedArticles) &&
      <FeedContainerList articles={_.map(article.relatedArticles, a => a.data)} config={{ title: 'Article.related_news' }} />;

    // Don't show byline for video articles that are created before June 14 and tagged with an ohmy email as author
    // TODO: Remove this check when the data has been sanitized
    const hasValidAuthor = article.authors && !!article.authors.length && (article.createdTimestamp > new Date('2016-06-14').getTime() || !_.includes(_.get(article, 'authors[0].data.email', ''), '@ohmy'));

    const hasVideo = !_.isEmpty(videos);
    const video = _.first(videos);
const autoplay_set = true;
    const hasPictureDescriptions = _.some(article.pictures, 'data.pictureText');

    return (
      <article ref="article" className="article" id={`article-${article.id}`}>
        <header>
          {
            hasVideo && csid &&
              <div className="zero-margin-container featured-container">
          
              
      	<Target article={article} autoplay={this.props.autoplay} isFirstArticle= {this.props.firstArticle} autoplay_freetexts={autoplay_freetexts}/>
                { video.data.videoText && <div className="media-description">{video.data.videoText}</div> }
              </div>
          }

          {
            !hasVideo &&
            <Slider className="zero-margin-container featured-container" navButtonTopAdjustment={hasPictureDescriptions ? 17 : 0}>
              {
                _.map(article.pictures, picture =>
                  <div key={picture.data.url}>
                    <div className="thumbnail">
                      <div className="image">
                        <PictureWithPreload src={picture.data.url} alt={article.title} size={4}/>
                      </div>
                    </div>
                    { picture.data.pictureText && <div className="media-description">{picture.data.pictureText}</div> }
                  </div>
                )
              }
            </Slider>
          }

          <ContentMeta data={article} />
          <h1>{article.title}</h1>
          <div className="article-content">
            {
              article.preamble && hasValidAuthor &&
                <p className="article-editor">
                  {this.context.app.t('Article.by')}
                  &nbsp;
                  {
                    article.authors.map(author => {
                      return author.data.name || author.data.email;
                    }).join(', ')
                  }
                </p>
            }
          </div>
        </header>
        <div className="article-content">
          <div className="preamble" dangerouslySetInnerHTML={rawMarkup((article.preamble || '').replace(/(\r\n|\r|\n)/g, '<br />'))}></div>
          
          { !_.isEmpty(factBoxWidgets) && <FactBox widget={factBoxWidgets[0]} /> }

          { _.head(polls) && <Poll poll={_.head(polls)} country={country} /> }

          {
            relatedBox && <aside className="article-related-news-sm visible-sm-up">
              { relatedBox }
            </aside>
          }

          { text && csid && <MarkdownConverter markdown={text.body} article={article} csid={csid} sovSeed={this.props.sovSeed} /> }

          {
            relatedBox &&
              <aside className="article-related-news-xs hidden-sm-up">
                { relatedBox }
              </aside>
          }

          {
            hasValidAuthor &&
              <ul className="byline">
                {
                  article.authors && article.authors.map(author => {
                    return (
                      <li key={author.data.email}>
                        {
                          author.links.picture.href &&
                            <div className="byline-image">
                              <Picture src={author.links.picture.href} alt={author.data.name} />
                            </div>
                        }
                        <span className="byline-name">{author.data.name}</span><br />
                        <a href={`mailto:${(author.data.email).replace('web@tv3sport.dk', 'netvagt@viaplaygroup.com').replace('netvagtonside@viasat.dk', 'netvagt@viaplaygroup.com').replace('@tv3sport.dk', '@viaplaygroup.com').replace('@nentgroup.com', '@viaplaygroup.com')}`}>{(author.data.email).replace('web@tv3sport.dk', 'netvagt@viaplaygroup.com').replace('netvagtonside@viasat.dk', 'netvagt@viaplaygroup.com').replace('@tv3sport.dk', '@viaplaygroup.com').replace('@nentgroup.com', '@viaplaygroup.com')}</a>
                      </li>
                    );
                  })
                }
            </ul>
          }

        </div>

        {
          article.podCast &&
            <div className="acast">
              <div>
                <iframe src={article.podCast.url} />
              </div>
            </div>
        }

        {
          _.map(enetPulseWidgets, widget =>
            <EnetpulseWidget key={JSON.stringify(widget.settings)} sport={widget.settings.sport} params={widget.settings.params} widgetType={widget.settings.type}/>
          )
        }

        {article.settings.enableComments && <FbCommentBox article={article} />}
		{/*value={getAdUnitPackage(country, 'Insider', breakpoint)}*/}
        {
          this.state.loadAdUnits &&
            <AdUnit
              id={this.id}
              value={getAdUnitPackage('dk', 'Insider', breakpoint)}
              callback={this.callback}
              country={country}
              isActiveSlot={!this.props.firstArticle}
              disable={this.state.disableAdUnit}
            />
        }

        <GoogleArticleRichCard article={article} country={country} isFirstArticle={this.props.firstArticle} />
      </article>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/Article.jsx